import ChecklistIcon from "@mui/icons-material/ChecklistRounded";
import TaskIcon from "@mui/icons-material/TaskAltRounded";
import { Box, Divider } from "@mui/material";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import useTabSearchParams from "@entrilia/shared/hooks/useTabSearchParams";
import { pageRoutes } from "../../../routes";
import VerticalNavigationMenuItem from "../../common/navigation/VerticalNavigationMenuItem";
import VerticalNavigationSection from "../../common/navigation/VerticalNavigationSection";
import VerticalNavigationWrapper from "../../common/navigation/VerticalNavigationWrapper";
import ObjectsListPage from "../../entityFields/grid/ObjectsListPage";
import ChecklistTypesTab from "./ChecklistTypesTab";
import { checklistsPageTabs, checklistsPageTabValues } from "./checklistsPageTabs";

const taskTemplateDetailsPathPattern = `/:clientCode/${pageRoutes.workflows}/${pageRoutes.checklists}/${pageRoutes.taskTemplates}/:id`;

const navigationItems = [
  { value: checklistsPageTabs.checklistTypes, label: "Checklist Types", Icon: ChecklistIcon },
  { value: checklistsPageTabs.taskTemplates, label: "Task Templates", Icon: TaskIcon },
] as const;

const ChecklistsPage = () => {
  usePageTitle("Checklists");

  const { selectedTab, onTabChange } = useTabSearchParams(checklistsPageTabValues);

  return (
    <Box sx={{ display: "flex", overflow: "hidden", height: "100%" }}>
      <VerticalNavigationWrapper>
        <VerticalNavigationSection title="Checklists">
          {navigationItems.map(({ value, label, Icon }) => {
            const selected = selectedTab === value;
            return (
              <VerticalNavigationMenuItem
                key={value}
                text={label}
                Icon={<Icon color={selected ? "primary" : "secondary"} />}
                selected={selected}
                onClick={() => onTabChange(value)}
              />
            );
          })}
        </VerticalNavigationSection>
      </VerticalNavigationWrapper>
      <Divider flexItem orientation="vertical" />
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, overflow: "hidden" }}>
        {selectedTab === checklistsPageTabs.checklistTypes && <ChecklistTypesTab />}
        {selectedTab === checklistsPageTabs.taskTemplates && (
          <ObjectsListPage
            objectType="ChecklistTaskTemplate"
            objectDetailsPathPattern={taskTemplateDetailsPathPattern}
            objectsTitle="Task Templates"
            allowCreate
            disablePageTitleUpdate
          />
        )}
      </Box>
    </Box>
  );
};

export default ChecklistsPage;
